import { useState } from 'react';
import Modal from "../CommonComponents/Modal";
import ModalBody from '../CommonComponents/ModalBody';
import Button from '../Button';
import InputField from '../CommonComponents/InputField';
import Toast from '../CommonComponents/Toast';


const Icon = ({ name = "cc" }) => {
    const icons = {
        cc: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 8.25L1.5 12L6 15.75" stroke="#F96343" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M18 8.25L22.5 12L18 15.75" stroke="#F96343" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15 3.75L9 20.25" stroke="#F96343" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        ),
        copy: (
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 20 20" fill="none">
                <g clip-path="url(#clip0_4265_187)">
                  <path d="M4.16663 12.5001H3.33329C2.89127 12.5001 2.46734 12.3245 2.15478 12.0119C1.84222 11.6994 1.66663 11.2754 1.66663 10.8334V3.33341C1.66663 2.89139 1.84222 2.46746 2.15478 2.1549C2.46734 1.84234 2.89127 1.66675 3.33329 1.66675H10.8333C11.2753 1.66675 11.6992 1.84234 12.0118 2.1549C12.3244 2.46746 12.5 2.89139 12.5 3.33341V4.16675M9.16663 7.50008H16.6666C17.5871 7.50008 18.3333 8.24627 18.3333 9.16675V16.6667C18.3333 17.5872 17.5871 18.3334 16.6666 18.3334H9.16663C8.24615 18.3334 7.49996 17.5872 7.49996 16.6667V9.16675C7.49996 8.24627 8.24615 7.50008 9.16663 7.50008Z" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_4265_187">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        ),
        link: (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 13C10.4295 13.5741 10.9774 14.0492 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9548 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.5521 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.47L11.75 5.18" stroke="#F96343" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14 11C13.5705 10.4259 13.0226 9.95083 12.3934 9.60706C11.7642 9.2633 11.0684 9.05889 10.3533 9.00768C9.63816 8.95646 8.92037 9.05964 8.24861 9.31023C7.57685 9.56082 6.96684 9.95296 6.46 10.46L3.46 13.46C2.5492 14.403 2.04522 15.6661 2.05661 16.977C2.06801 18.288 2.59385 19.5421 3.52089 20.4691C4.44793 21.3962 5.702 21.922 7.01298 21.9334C8.32396 21.9448 9.58697 21.4408 10.53 20.53L12.24 18.82" stroke="#F96343" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ),
        public: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="#4666D5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 12L11 14L15 10" stroke="#4666D5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ),
        closeIcon: (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15 5L5 15M5 5L15 15"
                    stroke="#667085"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        copied: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#f04438"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
        )
    };
    return icons[name] || icons.cc;
};

const SharePublicProfileHead = () => {
    return <div className="publicSharedTitle">
        <span>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="56" height="56" rx="12" fill="#FCEBE8"/>
            <g filter="url(#filter0_d_9247_9320)">
                <rect x="8" y="8" width="40" height="40" rx="8" fill="#F8E0DB"/>
                <path d="M36.332 36.3333L44.6654 28L36.332 19.6667M19.6654 19.6667L11.332 28L19.6654 36.3333M31.332 13L24.6654 43" stroke="#F55533" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <filter id="filter0_d_9247_9320" x="4" y="8" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.960784 0 0 0 0 0.333333 0 0 0 0 0.2 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9247_9320"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9247_9320" result="shape"/>
                </filter>
            </defs>
            </svg>

        </span>
        <div className="publicSharedTitleText">
            Share Public Profile
        </div>
    </div>
}


const SharePublicProfilePopUp = ({ openModal, setOpenModal, publicUrl = "gradious.com/cc" }) => {
    const [copied, setCopied] = useState(false);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState(false);
    const [toastType, setToastType] = useState("warning");

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(publicUrl || "gradious.com/cc");
            setCopied(true);
            setToastOpen(true);
            setToastMessage("Public URL is successfully copied!");
            setToastType("success");
            setTimeout(() => setCopied(false), 3000);
        } catch (err) {
            console.error("Copy failed", err);
        }
    };

    return (
        <>
        <Modal
            isOpen={openModal}
            title={<SharePublicProfileHead />}
            showCloseIcon
            onClose={() => setOpenModal(!openModal)}
            className="sharePublicProfileContainer"
            closeIcon={<Icon name="closeIcon" />}
        >
        <ModalBody
                content={
                    <div className='publicSharedContentDiv'>
                        <div className='publicSharedContenttitle'>Public URL</div>
                        <div className='publicSharedContentMain'>
                            <InputField
                              className="publicSharedInput"
                              value={publicUrl || ""}
                              leadingIcon={<span className="publicSharedInputIcon"><Icon name="link" /></span>}
                              readOnly={true} 
                              tabIndex={-1}
                              placeholder="gradious.com/cc"
                            />

                            <Button
                                size="sm"
                                disable={false}
                                className='publicSharedCopyButton'
                                onClick={handleCopy}
                                icon={{
                                    type: "leading",
                                    icon: <Icon name={copied? "copied" : "copy"} />,
                                }}
                                hierarchy={{
                                    type: "secondaryGrey",
                                    buttonText: copied ? "Copied" : "Copy Link",
                                }}
                            ></Button>
                        </div>
                        <div className="publicSharedDivider" />
                        <div className="publicSharedStatus">
                            <span className="publicSharedStatusIcon">
                                <Icon name="public" />
                            </span>
                            <span className="publicSharedStatusText">
                                <span className="publicSharedStatusTitle">This link is Public</span>
                                <span className="publicSharedStatusDescription">Anyone with this link can view your profile</span>
                            </span>
                        </div>
                   </div>
                }
            />

            {/* <Toast
                open={toastOpen}
                type={toastType}
                message={toastMessage}
                onClose={() => setToastOpen(false)}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            /> */}
       </Modal>
       </>
    );
};

export default SharePublicProfilePopUp;